import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MailOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mail_outline"}/>
}
